/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router';

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as AppImport } from './routes/_app';
import { Route as AppLandingImport } from './routes/_app/_landing';
import { Route as AppAuthenticatedImport } from './routes/_app/_authenticated';
import { Route as AppLandingIndexImport } from './routes/_app/_landing/index';
import { Route as AppInviteNewImport } from './routes/_app/invite/new';
import { Route as AppInviteExistingImport } from './routes/_app/invite/existing';
import { Route as AppInviteAcceptedImport } from './routes/_app/invite/accepted';
import { Route as AppAuthRenewImport } from './routes/_app/auth/renew';
import { Route as AppAuthRegisterImport } from './routes/_app/auth/register';
import { Route as AppAuthLogoutImport } from './routes/_app/auth/logout';
import { Route as AppAuthLoginImport } from './routes/_app/auth/login';
import { Route as AppLandingSolutionsImport } from './routes/_app/_landing/solutions';
import { Route as AppLandingPrivacyImport } from './routes/_app/_landing/privacy';
import { Route as AppLandingPricingImport } from './routes/_app/_landing/pricing';
import { Route as AppLandingContactImport } from './routes/_app/_landing/contact';
import { Route as AppAuthenticatedSettingsImport } from './routes/_app/_authenticated/settings';
import { Route as AppAuthenticatedMydigitalworkersImport } from './routes/_app/_authenticated/mydigitalworkers';
import { Route as AppAuthenticatedStoreIndexImport } from './routes/_app/_authenticated/store/index';
import { Route as AppAuthenticatedSetupIndexImport } from './routes/_app/_authenticated/setup/index';
import { Route as AppAuthenticatedSettingsIndexImport } from './routes/_app/_authenticated/settings/index';
import { Route as AppAuthenticatedMydigitalworkersIndexImport } from './routes/_app/_authenticated/mydigitalworkers/index';
import { Route as AppAuthenticatedStoreAccountingImport } from './routes/_app/_authenticated/store/accounting';
import { Route as AppAuthenticatedSetupOwnerImport } from './routes/_app/_authenticated/setup/owner';
import { Route as AppAuthenticatedSetupEmployeeImport } from './routes/_app/_authenticated/setup/employee';
import { Route as AppAuthenticatedSettingsUsersImport } from './routes/_app/_authenticated/settings/users';
import { Route as AppAuthenticatedSettingsSubscriptionImport } from './routes/_app/_authenticated/settings/subscription';
import { Route as AppAuthenticatedSettingsProfileImport } from './routes/_app/_authenticated/settings/profile';
import { Route as AppAuthenticatedSettingsPaymentImport } from './routes/_app/_authenticated/settings/payment';
import { Route as AppAuthenticatedSettingsCompanyImport } from './routes/_app/_authenticated/settings/company';
import { Route as AppAuthenticatedSettingsClientsImport } from './routes/_app/_authenticated/settings/clients';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout';
import { Route as AppAuthenticatedMydigitalworkersScoutSetupIndexImport } from './routes/_app/_authenticated/mydigitalworkers/scout/setup/index';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/index';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout/index';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout/index';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/requests';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/clients';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout/requests';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout/clients';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout/workpapers';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout/clients';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout/about';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/index';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/index';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/index';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/index';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/index';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/users';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/ssid';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/users';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/ssid';
import { Route as AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameImport } from './routes/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/$fileName';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/users';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/template';
import { Route as AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareImport } from './routes/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/accounting-software';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn.ita';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn.ica';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn.generalInterests';
import { Route as AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementImport } from './routes/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn.activityStatement';

// Create Virtual Routes

const AppAuthenticatedMydigitalworkersScoutImport = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/scout',
)();
const AppAuthenticatedMydigitalworkersOmniImport = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/omni',
)();
const AppAuthenticatedMydigitalworkersGaryImport = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/gary',
)();

// Create/Update Routes

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any);

const AppLandingRoute = AppLandingImport.update({
  id: '/_landing',
  getParentRoute: () => AppRoute,
} as any);

const AppAuthenticatedRoute = AppAuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => AppRoute,
} as any);

const AppLandingIndexRoute = AppLandingIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLandingRoute,
} as any);

const AppInviteNewRoute = AppInviteNewImport.update({
  id: '/invite/new',
  path: '/invite/new',
  getParentRoute: () => AppRoute,
} as any);

const AppInviteExistingRoute = AppInviteExistingImport.update({
  id: '/invite/existing',
  path: '/invite/existing',
  getParentRoute: () => AppRoute,
} as any);

const AppInviteAcceptedRoute = AppInviteAcceptedImport.update({
  id: '/invite/accepted',
  path: '/invite/accepted',
  getParentRoute: () => AppRoute,
} as any);

const AppAuthRenewRoute = AppAuthRenewImport.update({
  id: '/auth/renew',
  path: '/auth/renew',
  getParentRoute: () => AppRoute,
} as any);

const AppAuthRegisterRoute = AppAuthRegisterImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => AppRoute,
} as any);

const AppAuthLogoutRoute = AppAuthLogoutImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => AppRoute,
} as any);

const AppAuthLoginRoute = AppAuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => AppRoute,
} as any);

const AppLandingSolutionsRoute = AppLandingSolutionsImport.update({
  id: '/solutions',
  path: '/solutions',
  getParentRoute: () => AppLandingRoute,
} as any);

const AppLandingPrivacyRoute = AppLandingPrivacyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppLandingRoute,
} as any);

const AppLandingPricingRoute = AppLandingPricingImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppLandingRoute,
} as any);

const AppLandingContactRoute = AppLandingContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => AppLandingRoute,
} as any);

const AppAuthenticatedSettingsRoute = AppAuthenticatedSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAuthenticatedRoute,
} as any);

const AppAuthenticatedMydigitalworkersRoute =
  AppAuthenticatedMydigitalworkersImport.update({
    id: '/mydigitalworkers',
    path: '/mydigitalworkers',
    getParentRoute: () => AppAuthenticatedRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutRoute =
  AppAuthenticatedMydigitalworkersScoutImport.update({
    id: '/scout',
    path: '/scout',
    getParentRoute: () => AppAuthenticatedMydigitalworkersRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniRoute =
  AppAuthenticatedMydigitalworkersOmniImport.update({
    id: '/omni',
    path: '/omni',
    getParentRoute: () => AppAuthenticatedMydigitalworkersRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryRoute =
  AppAuthenticatedMydigitalworkersGaryImport.update({
    id: '/gary',
    path: '/gary',
    getParentRoute: () => AppAuthenticatedMydigitalworkersRoute,
  } as any);

const AppAuthenticatedStoreIndexRoute = AppAuthenticatedStoreIndexImport.update(
  {
    id: '/store/',
    path: '/store/',
    getParentRoute: () => AppAuthenticatedRoute,
  } as any,
);

const AppAuthenticatedSetupIndexRoute = AppAuthenticatedSetupIndexImport.update(
  {
    id: '/setup/',
    path: '/setup/',
    getParentRoute: () => AppAuthenticatedRoute,
  } as any,
);

const AppAuthenticatedSettingsIndexRoute =
  AppAuthenticatedSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthenticatedSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersIndexRoute =
  AppAuthenticatedMydigitalworkersIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthenticatedMydigitalworkersRoute,
  } as any);

const AppAuthenticatedStoreAccountingRoute =
  AppAuthenticatedStoreAccountingImport.update({
    id: '/store/accounting',
    path: '/store/accounting',
    getParentRoute: () => AppAuthenticatedRoute,
  } as any);

const AppAuthenticatedSetupOwnerRoute = AppAuthenticatedSetupOwnerImport.update(
  {
    id: '/setup/owner',
    path: '/setup/owner',
    getParentRoute: () => AppAuthenticatedRoute,
  } as any,
);

const AppAuthenticatedSetupEmployeeRoute =
  AppAuthenticatedSetupEmployeeImport.update({
    id: '/setup/employee',
    path: '/setup/employee',
    getParentRoute: () => AppAuthenticatedRoute,
  } as any);

const AppAuthenticatedSettingsUsersRoute =
  AppAuthenticatedSettingsUsersImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AppAuthenticatedSettingsRoute,
  } as any);

const AppAuthenticatedSettingsSubscriptionRoute =
  AppAuthenticatedSettingsSubscriptionImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AppAuthenticatedSettingsRoute,
  } as any);

const AppAuthenticatedSettingsProfileRoute =
  AppAuthenticatedSettingsProfileImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AppAuthenticatedSettingsRoute,
  } as any);

const AppAuthenticatedSettingsPaymentRoute =
  AppAuthenticatedSettingsPaymentImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => AppAuthenticatedSettingsRoute,
  } as any);

const AppAuthenticatedSettingsCompanyRoute =
  AppAuthenticatedSettingsCompanyImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AppAuthenticatedSettingsRoute,
  } as any);

const AppAuthenticatedSettingsClientsRoute =
  AppAuthenticatedSettingsClientsImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AppAuthenticatedSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutImport.update({
    id: '/_scoutLayout',
    getParentRoute: () => AppAuthenticatedMydigitalworkersScoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutImport.update({
    id: '/_omniLayout',
    getParentRoute: () => AppAuthenticatedMydigitalworkersOmniRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutImport.update({
    id: '/_garyLayout',
    getParentRoute: () => AppAuthenticatedMydigitalworkersGaryRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutSetupIndexRoute =
  AppAuthenticatedMydigitalworkersScoutSetupIndexImport.update({
    id: '/setup/',
    path: '/setup/',
    getParentRoute: () => AppAuthenticatedMydigitalworkersScoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthenticatedMydigitalworkersGaryGaryLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersImport.update({
    id: '/workpapers',
    path: '/workpapers',
    getParentRoute: () => AppAuthenticatedMydigitalworkersGaryGaryLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppAuthenticatedMydigitalworkersGaryGaryLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AppAuthenticatedMydigitalworkersGaryGaryLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutImport.update({
    id: '/about',
    path: '/about',
    getParentRoute: () => AppAuthenticatedMydigitalworkersGaryGaryLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexImport.update({
    id: '/$clientId/',
    path: '/$clientId/',
    getParentRoute: () => AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () =>
      AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidImport.update({
    id: '/ssid',
    path: '/ssid',
    getParentRoute: () =>
      AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () =>
      AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidImport.update({
    id: '/ssid',
    path: '/ssid',
    getParentRoute: () =>
      AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameRoute =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameImport.update({
    id: '/$clientId/$fileName',
    path: '/$clientId/$fileName',
    getParentRoute: () => AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () =>
      AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateImport.update({
    id: '/template',
    path: '/template',
    getParentRoute: () =>
      AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRoute,
  } as any);

const AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareRoute =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareImport.update(
    {
      id: '/accounting-software',
      path: '/accounting-software',
      getParentRoute: () =>
        AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRoute,
    } as any,
  );

const AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaImport.update(
    {
      id: '/$abn/ita',
      path: '/$abn/ita',
      getParentRoute: () =>
        AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRoute,
    } as any,
  );

const AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaImport.update(
    {
      id: '/$abn/ica',
      path: '/$abn/ica',
      getParentRoute: () =>
        AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRoute,
    } as any,
  );

const AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsImport.update(
    {
      id: '/$abn/generalInterests',
      path: '/$abn/generalInterests',
      getParentRoute: () =>
        AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRoute,
    } as any,
  );

const AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementRoute =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementImport.update(
    {
      id: '/$abn/activityStatement',
      path: '/$abn/activityStatement',
      getParentRoute: () =>
        AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRoute,
    } as any,
  );

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AppImport;
      parentRoute: typeof rootRoute;
    };
    '/_app/_authenticated': {
      id: '/_app/_authenticated';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AppAuthenticatedImport;
      parentRoute: typeof AppImport;
    };
    '/_app/_landing': {
      id: '/_app/_landing';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AppLandingImport;
      parentRoute: typeof AppImport;
    };
    '/_app/_authenticated/mydigitalworkers': {
      id: '/_app/_authenticated/mydigitalworkers';
      path: '/mydigitalworkers';
      fullPath: '/mydigitalworkers';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersImport;
      parentRoute: typeof AppAuthenticatedImport;
    };
    '/_app/_authenticated/settings': {
      id: '/_app/_authenticated/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof AppAuthenticatedSettingsImport;
      parentRoute: typeof AppAuthenticatedImport;
    };
    '/_app/_landing/contact': {
      id: '/_app/_landing/contact';
      path: '/contact';
      fullPath: '/contact';
      preLoaderRoute: typeof AppLandingContactImport;
      parentRoute: typeof AppLandingImport;
    };
    '/_app/_landing/pricing': {
      id: '/_app/_landing/pricing';
      path: '/pricing';
      fullPath: '/pricing';
      preLoaderRoute: typeof AppLandingPricingImport;
      parentRoute: typeof AppLandingImport;
    };
    '/_app/_landing/privacy': {
      id: '/_app/_landing/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof AppLandingPrivacyImport;
      parentRoute: typeof AppLandingImport;
    };
    '/_app/_landing/solutions': {
      id: '/_app/_landing/solutions';
      path: '/solutions';
      fullPath: '/solutions';
      preLoaderRoute: typeof AppLandingSolutionsImport;
      parentRoute: typeof AppLandingImport;
    };
    '/_app/auth/login': {
      id: '/_app/auth/login';
      path: '/auth/login';
      fullPath: '/auth/login';
      preLoaderRoute: typeof AppAuthLoginImport;
      parentRoute: typeof AppImport;
    };
    '/_app/auth/logout': {
      id: '/_app/auth/logout';
      path: '/auth/logout';
      fullPath: '/auth/logout';
      preLoaderRoute: typeof AppAuthLogoutImport;
      parentRoute: typeof AppImport;
    };
    '/_app/auth/register': {
      id: '/_app/auth/register';
      path: '/auth/register';
      fullPath: '/auth/register';
      preLoaderRoute: typeof AppAuthRegisterImport;
      parentRoute: typeof AppImport;
    };
    '/_app/auth/renew': {
      id: '/_app/auth/renew';
      path: '/auth/renew';
      fullPath: '/auth/renew';
      preLoaderRoute: typeof AppAuthRenewImport;
      parentRoute: typeof AppImport;
    };
    '/_app/invite/accepted': {
      id: '/_app/invite/accepted';
      path: '/invite/accepted';
      fullPath: '/invite/accepted';
      preLoaderRoute: typeof AppInviteAcceptedImport;
      parentRoute: typeof AppImport;
    };
    '/_app/invite/existing': {
      id: '/_app/invite/existing';
      path: '/invite/existing';
      fullPath: '/invite/existing';
      preLoaderRoute: typeof AppInviteExistingImport;
      parentRoute: typeof AppImport;
    };
    '/_app/invite/new': {
      id: '/_app/invite/new';
      path: '/invite/new';
      fullPath: '/invite/new';
      preLoaderRoute: typeof AppInviteNewImport;
      parentRoute: typeof AppImport;
    };
    '/_app/_landing/': {
      id: '/_app/_landing/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AppLandingIndexImport;
      parentRoute: typeof AppLandingImport;
    };
    '/_app/_authenticated/settings/clients': {
      id: '/_app/_authenticated/settings/clients';
      path: '/clients';
      fullPath: '/settings/clients';
      preLoaderRoute: typeof AppAuthenticatedSettingsClientsImport;
      parentRoute: typeof AppAuthenticatedSettingsImport;
    };
    '/_app/_authenticated/settings/company': {
      id: '/_app/_authenticated/settings/company';
      path: '/company';
      fullPath: '/settings/company';
      preLoaderRoute: typeof AppAuthenticatedSettingsCompanyImport;
      parentRoute: typeof AppAuthenticatedSettingsImport;
    };
    '/_app/_authenticated/settings/payment': {
      id: '/_app/_authenticated/settings/payment';
      path: '/payment';
      fullPath: '/settings/payment';
      preLoaderRoute: typeof AppAuthenticatedSettingsPaymentImport;
      parentRoute: typeof AppAuthenticatedSettingsImport;
    };
    '/_app/_authenticated/settings/profile': {
      id: '/_app/_authenticated/settings/profile';
      path: '/profile';
      fullPath: '/settings/profile';
      preLoaderRoute: typeof AppAuthenticatedSettingsProfileImport;
      parentRoute: typeof AppAuthenticatedSettingsImport;
    };
    '/_app/_authenticated/settings/subscription': {
      id: '/_app/_authenticated/settings/subscription';
      path: '/subscription';
      fullPath: '/settings/subscription';
      preLoaderRoute: typeof AppAuthenticatedSettingsSubscriptionImport;
      parentRoute: typeof AppAuthenticatedSettingsImport;
    };
    '/_app/_authenticated/settings/users': {
      id: '/_app/_authenticated/settings/users';
      path: '/users';
      fullPath: '/settings/users';
      preLoaderRoute: typeof AppAuthenticatedSettingsUsersImport;
      parentRoute: typeof AppAuthenticatedSettingsImport;
    };
    '/_app/_authenticated/setup/employee': {
      id: '/_app/_authenticated/setup/employee';
      path: '/setup/employee';
      fullPath: '/setup/employee';
      preLoaderRoute: typeof AppAuthenticatedSetupEmployeeImport;
      parentRoute: typeof AppAuthenticatedImport;
    };
    '/_app/_authenticated/setup/owner': {
      id: '/_app/_authenticated/setup/owner';
      path: '/setup/owner';
      fullPath: '/setup/owner';
      preLoaderRoute: typeof AppAuthenticatedSetupOwnerImport;
      parentRoute: typeof AppAuthenticatedImport;
    };
    '/_app/_authenticated/store/accounting': {
      id: '/_app/_authenticated/store/accounting';
      path: '/store/accounting';
      fullPath: '/store/accounting';
      preLoaderRoute: typeof AppAuthenticatedStoreAccountingImport;
      parentRoute: typeof AppAuthenticatedImport;
    };
    '/_app/_authenticated/mydigitalworkers/': {
      id: '/_app/_authenticated/mydigitalworkers/';
      path: '/';
      fullPath: '/mydigitalworkers/';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersImport;
    };
    '/_app/_authenticated/settings/': {
      id: '/_app/_authenticated/settings/';
      path: '/';
      fullPath: '/settings/';
      preLoaderRoute: typeof AppAuthenticatedSettingsIndexImport;
      parentRoute: typeof AppAuthenticatedSettingsImport;
    };
    '/_app/_authenticated/setup/': {
      id: '/_app/_authenticated/setup/';
      path: '/setup';
      fullPath: '/setup';
      preLoaderRoute: typeof AppAuthenticatedSetupIndexImport;
      parentRoute: typeof AppAuthenticatedImport;
    };
    '/_app/_authenticated/store/': {
      id: '/_app/_authenticated/store/';
      path: '/store';
      fullPath: '/store';
      preLoaderRoute: typeof AppAuthenticatedStoreIndexImport;
      parentRoute: typeof AppAuthenticatedImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary': {
      id: '/_app/_authenticated/mydigitalworkers/gary';
      path: '/gary';
      fullPath: '/mydigitalworkers/gary';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout';
      path: '/gary';
      fullPath: '/mydigitalworkers/gary';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryRoute;
    };
    '/_app/_authenticated/mydigitalworkers/omni': {
      id: '/_app/_authenticated/mydigitalworkers/omni';
      path: '/omni';
      fullPath: '/mydigitalworkers/omni';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout';
      path: '/omni';
      fullPath: '/mydigitalworkers/omni';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniRoute;
    };
    '/_app/_authenticated/mydigitalworkers/scout': {
      id: '/_app/_authenticated/mydigitalworkers/scout';
      path: '/scout';
      fullPath: '/mydigitalworkers/scout';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout';
      path: '/scout';
      fullPath: '/mydigitalworkers/scout';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutRoute;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/about': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/about';
      path: '/about';
      fullPath: '/mydigitalworkers/gary/about';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/clients': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/clients';
      path: '/clients';
      fullPath: '/mydigitalworkers/gary/clients';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings';
      path: '/settings';
      fullPath: '/mydigitalworkers/gary/settings';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/workpapers': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/workpapers';
      path: '/workpapers';
      fullPath: '/mydigitalworkers/gary/workpapers';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/clients': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/clients';
      path: '/clients';
      fullPath: '/mydigitalworkers/omni/clients';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/requests': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/requests';
      path: '/requests';
      fullPath: '/mydigitalworkers/omni/requests';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings';
      path: '/settings';
      fullPath: '/mydigitalworkers/omni/settings';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/clients': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/clients';
      path: '/clients';
      fullPath: '/mydigitalworkers/scout/clients';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/requests': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/requests';
      path: '/requests';
      fullPath: '/mydigitalworkers/scout/requests';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings';
      path: '/settings';
      fullPath: '/mydigitalworkers/scout/settings';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/';
      path: '/';
      fullPath: '/mydigitalworkers/gary/';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/';
      path: '/';
      fullPath: '/mydigitalworkers/omni/';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/';
      path: '/';
      fullPath: '/mydigitalworkers/scout/';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/setup/': {
      id: '/_app/_authenticated/mydigitalworkers/scout/setup/';
      path: '/setup';
      fullPath: '/mydigitalworkers/scout/setup';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutSetupIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/accounting-software': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/accounting-software';
      path: '/accounting-software';
      fullPath: '/mydigitalworkers/gary/settings/accounting-software';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/template': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/template';
      path: '/template';
      fullPath: '/mydigitalworkers/gary/settings/template';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/users': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/users';
      path: '/users';
      fullPath: '/mydigitalworkers/gary/settings/users';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/$fileName': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/$fileName';
      path: '/$clientId/$fileName';
      fullPath: '/mydigitalworkers/omni/$clientId/$fileName';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/ssid': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/ssid';
      path: '/ssid';
      fullPath: '/mydigitalworkers/omni/settings/ssid';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/users': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/users';
      path: '/users';
      fullPath: '/mydigitalworkers/omni/settings/users';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId';
      path: '/reports/$reportId';
      fullPath: '/mydigitalworkers/scout/reports/$reportId';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/ssid': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/ssid';
      path: '/ssid';
      fullPath: '/mydigitalworkers/scout/settings/ssid';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/users': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/users';
      path: '/users';
      fullPath: '/mydigitalworkers/scout/settings/users';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/': {
      id: '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/';
      path: '/';
      fullPath: '/mydigitalworkers/gary/settings/';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/';
      path: '/$clientId';
      fullPath: '/mydigitalworkers/omni/$clientId';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/': {
      id: '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/';
      path: '/';
      fullPath: '/mydigitalworkers/omni/settings/';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/';
      path: '/reports';
      fullPath: '/mydigitalworkers/scout/reports';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/';
      path: '/';
      fullPath: '/mydigitalworkers/scout/settings/';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/activityStatement': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/activityStatement';
      path: '/$abn/activityStatement';
      fullPath: '/mydigitalworkers/scout/reports/$reportId/$abn/activityStatement';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/generalInterests': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/generalInterests';
      path: '/$abn/generalInterests';
      fullPath: '/mydigitalworkers/scout/reports/$reportId/$abn/generalInterests';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ica': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ica';
      path: '/$abn/ica';
      fullPath: '/mydigitalworkers/scout/reports/$reportId/$abn/ica';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdImport;
    };
    '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ita': {
      id: '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ita';
      path: '/$abn/ita';
      fullPath: '/mydigitalworkers/scout/reports/$reportId/$abn/ita';
      preLoaderRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaImport;
      parentRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdImport;
    };
  }
}

// Create and export the route tree

interface AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRouteChildren {
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareRoute;
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateRoute;
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersRoute;
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexRoute;
}

const AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRouteChildren: AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRouteChildren =
  {
    AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareRoute,
    AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateRoute,
    AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersRoute,
    AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexRoute,
  };

const AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRouteWithChildren =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersGaryGaryLayoutRouteChildren {
  AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutRoute;
  AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsRoute;
  AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRouteWithChildren;
  AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersRoute;
  AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexRoute;
}

const AppAuthenticatedMydigitalworkersGaryGaryLayoutRouteChildren: AppAuthenticatedMydigitalworkersGaryGaryLayoutRouteChildren =
  {
    AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutRoute,
    AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsRoute,
    AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRouteWithChildren,
    AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersRoute,
    AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexRoute,
  };

const AppAuthenticatedMydigitalworkersGaryGaryLayoutRouteWithChildren =
  AppAuthenticatedMydigitalworkersGaryGaryLayoutRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersGaryGaryLayoutRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersGaryRouteChildren {
  AppAuthenticatedMydigitalworkersGaryGaryLayoutRoute: typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutRouteWithChildren;
}

const AppAuthenticatedMydigitalworkersGaryRouteChildren: AppAuthenticatedMydigitalworkersGaryRouteChildren =
  {
    AppAuthenticatedMydigitalworkersGaryGaryLayoutRoute:
      AppAuthenticatedMydigitalworkersGaryGaryLayoutRouteWithChildren,
  };

const AppAuthenticatedMydigitalworkersGaryRouteWithChildren =
  AppAuthenticatedMydigitalworkersGaryRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersGaryRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRouteChildren {
  AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidRoute;
  AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersRoute;
  AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexRoute;
}

const AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRouteChildren: AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRouteChildren =
  {
    AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidRoute,
    AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersRoute,
    AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexRoute,
  };

const AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRouteWithChildren =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersOmniOmniLayoutRouteChildren {
  AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsRoute;
  AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsRoute;
  AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRouteWithChildren;
  AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexRoute;
  AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameRoute;
  AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexRoute;
}

const AppAuthenticatedMydigitalworkersOmniOmniLayoutRouteChildren: AppAuthenticatedMydigitalworkersOmniOmniLayoutRouteChildren =
  {
    AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsRoute,
    AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsRoute,
    AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRouteWithChildren,
    AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexRoute,
    AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameRoute,
    AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexRoute,
  };

const AppAuthenticatedMydigitalworkersOmniOmniLayoutRouteWithChildren =
  AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersOmniOmniLayoutRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersOmniRouteChildren {
  AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute: typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutRouteWithChildren;
}

const AppAuthenticatedMydigitalworkersOmniRouteChildren: AppAuthenticatedMydigitalworkersOmniRouteChildren =
  {
    AppAuthenticatedMydigitalworkersOmniOmniLayoutRoute:
      AppAuthenticatedMydigitalworkersOmniOmniLayoutRouteWithChildren,
  };

const AppAuthenticatedMydigitalworkersOmniRouteWithChildren =
  AppAuthenticatedMydigitalworkersOmniRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersOmniRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRouteChildren {
  AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidRoute;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersRoute;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexRoute;
}

const AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRouteChildren: AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRouteChildren =
  {
    AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidRoute,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersRoute,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexRoute,
  };

const AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRouteWithChildren =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteChildren {
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementRoute;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsRoute;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaRoute;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaRoute;
}

const AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteChildren: AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteChildren =
  {
    AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementRoute,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsRoute,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaRoute,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaRoute,
  };

const AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteWithChildren =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersScoutScoutLayoutRouteChildren {
  AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsRoute;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsRoute;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRouteWithChildren;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexRoute;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteWithChildren;
  AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexRoute;
}

const AppAuthenticatedMydigitalworkersScoutScoutLayoutRouteChildren: AppAuthenticatedMydigitalworkersScoutScoutLayoutRouteChildren =
  {
    AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsRoute,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsRoute,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRouteWithChildren,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexRoute,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteWithChildren,
    AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexRoute,
  };

const AppAuthenticatedMydigitalworkersScoutScoutLayoutRouteWithChildren =
  AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersScoutScoutLayoutRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersScoutRouteChildren {
  AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute: typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutRouteWithChildren;
  AppAuthenticatedMydigitalworkersScoutSetupIndexRoute: typeof AppAuthenticatedMydigitalworkersScoutSetupIndexRoute;
}

const AppAuthenticatedMydigitalworkersScoutRouteChildren: AppAuthenticatedMydigitalworkersScoutRouteChildren =
  {
    AppAuthenticatedMydigitalworkersScoutScoutLayoutRoute:
      AppAuthenticatedMydigitalworkersScoutScoutLayoutRouteWithChildren,
    AppAuthenticatedMydigitalworkersScoutSetupIndexRoute:
      AppAuthenticatedMydigitalworkersScoutSetupIndexRoute,
  };

const AppAuthenticatedMydigitalworkersScoutRouteWithChildren =
  AppAuthenticatedMydigitalworkersScoutRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersScoutRouteChildren,
  );

interface AppAuthenticatedMydigitalworkersRouteChildren {
  AppAuthenticatedMydigitalworkersIndexRoute: typeof AppAuthenticatedMydigitalworkersIndexRoute;
  AppAuthenticatedMydigitalworkersGaryRoute: typeof AppAuthenticatedMydigitalworkersGaryRouteWithChildren;
  AppAuthenticatedMydigitalworkersOmniRoute: typeof AppAuthenticatedMydigitalworkersOmniRouteWithChildren;
  AppAuthenticatedMydigitalworkersScoutRoute: typeof AppAuthenticatedMydigitalworkersScoutRouteWithChildren;
}

const AppAuthenticatedMydigitalworkersRouteChildren: AppAuthenticatedMydigitalworkersRouteChildren =
  {
    AppAuthenticatedMydigitalworkersIndexRoute:
      AppAuthenticatedMydigitalworkersIndexRoute,
    AppAuthenticatedMydigitalworkersGaryRoute:
      AppAuthenticatedMydigitalworkersGaryRouteWithChildren,
    AppAuthenticatedMydigitalworkersOmniRoute:
      AppAuthenticatedMydigitalworkersOmniRouteWithChildren,
    AppAuthenticatedMydigitalworkersScoutRoute:
      AppAuthenticatedMydigitalworkersScoutRouteWithChildren,
  };

const AppAuthenticatedMydigitalworkersRouteWithChildren =
  AppAuthenticatedMydigitalworkersRoute._addFileChildren(
    AppAuthenticatedMydigitalworkersRouteChildren,
  );

interface AppAuthenticatedSettingsRouteChildren {
  AppAuthenticatedSettingsClientsRoute: typeof AppAuthenticatedSettingsClientsRoute;
  AppAuthenticatedSettingsCompanyRoute: typeof AppAuthenticatedSettingsCompanyRoute;
  AppAuthenticatedSettingsPaymentRoute: typeof AppAuthenticatedSettingsPaymentRoute;
  AppAuthenticatedSettingsProfileRoute: typeof AppAuthenticatedSettingsProfileRoute;
  AppAuthenticatedSettingsSubscriptionRoute: typeof AppAuthenticatedSettingsSubscriptionRoute;
  AppAuthenticatedSettingsUsersRoute: typeof AppAuthenticatedSettingsUsersRoute;
  AppAuthenticatedSettingsIndexRoute: typeof AppAuthenticatedSettingsIndexRoute;
}

const AppAuthenticatedSettingsRouteChildren: AppAuthenticatedSettingsRouteChildren =
  {
    AppAuthenticatedSettingsClientsRoute: AppAuthenticatedSettingsClientsRoute,
    AppAuthenticatedSettingsCompanyRoute: AppAuthenticatedSettingsCompanyRoute,
    AppAuthenticatedSettingsPaymentRoute: AppAuthenticatedSettingsPaymentRoute,
    AppAuthenticatedSettingsProfileRoute: AppAuthenticatedSettingsProfileRoute,
    AppAuthenticatedSettingsSubscriptionRoute:
      AppAuthenticatedSettingsSubscriptionRoute,
    AppAuthenticatedSettingsUsersRoute: AppAuthenticatedSettingsUsersRoute,
    AppAuthenticatedSettingsIndexRoute: AppAuthenticatedSettingsIndexRoute,
  };

const AppAuthenticatedSettingsRouteWithChildren =
  AppAuthenticatedSettingsRoute._addFileChildren(
    AppAuthenticatedSettingsRouteChildren,
  );

interface AppAuthenticatedRouteChildren {
  AppAuthenticatedMydigitalworkersRoute: typeof AppAuthenticatedMydigitalworkersRouteWithChildren;
  AppAuthenticatedSettingsRoute: typeof AppAuthenticatedSettingsRouteWithChildren;
  AppAuthenticatedSetupEmployeeRoute: typeof AppAuthenticatedSetupEmployeeRoute;
  AppAuthenticatedSetupOwnerRoute: typeof AppAuthenticatedSetupOwnerRoute;
  AppAuthenticatedStoreAccountingRoute: typeof AppAuthenticatedStoreAccountingRoute;
  AppAuthenticatedSetupIndexRoute: typeof AppAuthenticatedSetupIndexRoute;
  AppAuthenticatedStoreIndexRoute: typeof AppAuthenticatedStoreIndexRoute;
}

const AppAuthenticatedRouteChildren: AppAuthenticatedRouteChildren = {
  AppAuthenticatedMydigitalworkersRoute:
    AppAuthenticatedMydigitalworkersRouteWithChildren,
  AppAuthenticatedSettingsRoute: AppAuthenticatedSettingsRouteWithChildren,
  AppAuthenticatedSetupEmployeeRoute: AppAuthenticatedSetupEmployeeRoute,
  AppAuthenticatedSetupOwnerRoute: AppAuthenticatedSetupOwnerRoute,
  AppAuthenticatedStoreAccountingRoute: AppAuthenticatedStoreAccountingRoute,
  AppAuthenticatedSetupIndexRoute: AppAuthenticatedSetupIndexRoute,
  AppAuthenticatedStoreIndexRoute: AppAuthenticatedStoreIndexRoute,
};

const AppAuthenticatedRouteWithChildren =
  AppAuthenticatedRoute._addFileChildren(AppAuthenticatedRouteChildren);

interface AppLandingRouteChildren {
  AppLandingContactRoute: typeof AppLandingContactRoute;
  AppLandingPricingRoute: typeof AppLandingPricingRoute;
  AppLandingPrivacyRoute: typeof AppLandingPrivacyRoute;
  AppLandingSolutionsRoute: typeof AppLandingSolutionsRoute;
  AppLandingIndexRoute: typeof AppLandingIndexRoute;
}

const AppLandingRouteChildren: AppLandingRouteChildren = {
  AppLandingContactRoute: AppLandingContactRoute,
  AppLandingPricingRoute: AppLandingPricingRoute,
  AppLandingPrivacyRoute: AppLandingPrivacyRoute,
  AppLandingSolutionsRoute: AppLandingSolutionsRoute,
  AppLandingIndexRoute: AppLandingIndexRoute,
};

const AppLandingRouteWithChildren = AppLandingRoute._addFileChildren(
  AppLandingRouteChildren,
);

interface AppRouteChildren {
  AppAuthenticatedRoute: typeof AppAuthenticatedRouteWithChildren;
  AppLandingRoute: typeof AppLandingRouteWithChildren;
  AppAuthLoginRoute: typeof AppAuthLoginRoute;
  AppAuthLogoutRoute: typeof AppAuthLogoutRoute;
  AppAuthRegisterRoute: typeof AppAuthRegisterRoute;
  AppAuthRenewRoute: typeof AppAuthRenewRoute;
  AppInviteAcceptedRoute: typeof AppInviteAcceptedRoute;
  AppInviteExistingRoute: typeof AppInviteExistingRoute;
  AppInviteNewRoute: typeof AppInviteNewRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppAuthenticatedRoute: AppAuthenticatedRouteWithChildren,
  AppLandingRoute: AppLandingRouteWithChildren,
  AppAuthLoginRoute: AppAuthLoginRoute,
  AppAuthLogoutRoute: AppAuthLogoutRoute,
  AppAuthRegisterRoute: AppAuthRegisterRoute,
  AppAuthRenewRoute: AppAuthRenewRoute,
  AppInviteAcceptedRoute: AppInviteAcceptedRoute,
  AppInviteExistingRoute: AppInviteExistingRoute,
  AppInviteNewRoute: AppInviteNewRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

export interface FileRoutesByFullPath {
  '': typeof AppLandingRouteWithChildren;
  '/mydigitalworkers': typeof AppAuthenticatedMydigitalworkersRouteWithChildren;
  '/settings': typeof AppAuthenticatedSettingsRouteWithChildren;
  '/contact': typeof AppLandingContactRoute;
  '/pricing': typeof AppLandingPricingRoute;
  '/privacy': typeof AppLandingPrivacyRoute;
  '/solutions': typeof AppLandingSolutionsRoute;
  '/auth/login': typeof AppAuthLoginRoute;
  '/auth/logout': typeof AppAuthLogoutRoute;
  '/auth/register': typeof AppAuthRegisterRoute;
  '/auth/renew': typeof AppAuthRenewRoute;
  '/invite/accepted': typeof AppInviteAcceptedRoute;
  '/invite/existing': typeof AppInviteExistingRoute;
  '/invite/new': typeof AppInviteNewRoute;
  '/': typeof AppLandingIndexRoute;
  '/settings/clients': typeof AppAuthenticatedSettingsClientsRoute;
  '/settings/company': typeof AppAuthenticatedSettingsCompanyRoute;
  '/settings/payment': typeof AppAuthenticatedSettingsPaymentRoute;
  '/settings/profile': typeof AppAuthenticatedSettingsProfileRoute;
  '/settings/subscription': typeof AppAuthenticatedSettingsSubscriptionRoute;
  '/settings/users': typeof AppAuthenticatedSettingsUsersRoute;
  '/setup/employee': typeof AppAuthenticatedSetupEmployeeRoute;
  '/setup/owner': typeof AppAuthenticatedSetupOwnerRoute;
  '/store/accounting': typeof AppAuthenticatedStoreAccountingRoute;
  '/mydigitalworkers/': typeof AppAuthenticatedMydigitalworkersIndexRoute;
  '/settings/': typeof AppAuthenticatedSettingsIndexRoute;
  '/setup': typeof AppAuthenticatedSetupIndexRoute;
  '/store': typeof AppAuthenticatedStoreIndexRoute;
  '/mydigitalworkers/gary': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutRouteWithChildren;
  '/mydigitalworkers/omni': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutRouteWithChildren;
  '/mydigitalworkers/scout': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutRouteWithChildren;
  '/mydigitalworkers/gary/about': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutRoute;
  '/mydigitalworkers/gary/clients': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsRoute;
  '/mydigitalworkers/gary/settings': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRouteWithChildren;
  '/mydigitalworkers/gary/workpapers': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersRoute;
  '/mydigitalworkers/omni/clients': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsRoute;
  '/mydigitalworkers/omni/requests': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsRoute;
  '/mydigitalworkers/omni/settings': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRouteWithChildren;
  '/mydigitalworkers/scout/clients': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsRoute;
  '/mydigitalworkers/scout/requests': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsRoute;
  '/mydigitalworkers/scout/settings': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRouteWithChildren;
  '/mydigitalworkers/gary/': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexRoute;
  '/mydigitalworkers/omni/': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexRoute;
  '/mydigitalworkers/scout/': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexRoute;
  '/mydigitalworkers/scout/setup': typeof AppAuthenticatedMydigitalworkersScoutSetupIndexRoute;
  '/mydigitalworkers/gary/settings/accounting-software': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareRoute;
  '/mydigitalworkers/gary/settings/template': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateRoute;
  '/mydigitalworkers/gary/settings/users': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersRoute;
  '/mydigitalworkers/omni/$clientId/$fileName': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameRoute;
  '/mydigitalworkers/omni/settings/ssid': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidRoute;
  '/mydigitalworkers/omni/settings/users': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersRoute;
  '/mydigitalworkers/scout/reports/$reportId': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteWithChildren;
  '/mydigitalworkers/scout/settings/ssid': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidRoute;
  '/mydigitalworkers/scout/settings/users': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersRoute;
  '/mydigitalworkers/gary/settings/': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexRoute;
  '/mydigitalworkers/omni/$clientId': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexRoute;
  '/mydigitalworkers/omni/settings/': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexRoute;
  '/mydigitalworkers/scout/reports': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexRoute;
  '/mydigitalworkers/scout/settings/': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexRoute;
  '/mydigitalworkers/scout/reports/$reportId/$abn/activityStatement': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementRoute;
  '/mydigitalworkers/scout/reports/$reportId/$abn/generalInterests': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsRoute;
  '/mydigitalworkers/scout/reports/$reportId/$abn/ica': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaRoute;
  '/mydigitalworkers/scout/reports/$reportId/$abn/ita': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaRoute;
}

export interface FileRoutesByTo {
  '': typeof AppAuthenticatedRouteWithChildren;
  '/contact': typeof AppLandingContactRoute;
  '/pricing': typeof AppLandingPricingRoute;
  '/privacy': typeof AppLandingPrivacyRoute;
  '/solutions': typeof AppLandingSolutionsRoute;
  '/auth/login': typeof AppAuthLoginRoute;
  '/auth/logout': typeof AppAuthLogoutRoute;
  '/auth/register': typeof AppAuthRegisterRoute;
  '/auth/renew': typeof AppAuthRenewRoute;
  '/invite/accepted': typeof AppInviteAcceptedRoute;
  '/invite/existing': typeof AppInviteExistingRoute;
  '/invite/new': typeof AppInviteNewRoute;
  '/': typeof AppLandingIndexRoute;
  '/settings/clients': typeof AppAuthenticatedSettingsClientsRoute;
  '/settings/company': typeof AppAuthenticatedSettingsCompanyRoute;
  '/settings/payment': typeof AppAuthenticatedSettingsPaymentRoute;
  '/settings/profile': typeof AppAuthenticatedSettingsProfileRoute;
  '/settings/subscription': typeof AppAuthenticatedSettingsSubscriptionRoute;
  '/settings/users': typeof AppAuthenticatedSettingsUsersRoute;
  '/setup/employee': typeof AppAuthenticatedSetupEmployeeRoute;
  '/setup/owner': typeof AppAuthenticatedSetupOwnerRoute;
  '/store/accounting': typeof AppAuthenticatedStoreAccountingRoute;
  '/mydigitalworkers': typeof AppAuthenticatedMydigitalworkersIndexRoute;
  '/settings': typeof AppAuthenticatedSettingsIndexRoute;
  '/setup': typeof AppAuthenticatedSetupIndexRoute;
  '/store': typeof AppAuthenticatedStoreIndexRoute;
  '/mydigitalworkers/gary': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexRoute;
  '/mydigitalworkers/omni': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexRoute;
  '/mydigitalworkers/scout': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexRoute;
  '/mydigitalworkers/gary/about': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutRoute;
  '/mydigitalworkers/gary/clients': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsRoute;
  '/mydigitalworkers/gary/workpapers': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersRoute;
  '/mydigitalworkers/omni/clients': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsRoute;
  '/mydigitalworkers/omni/requests': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsRoute;
  '/mydigitalworkers/scout/clients': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsRoute;
  '/mydigitalworkers/scout/requests': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsRoute;
  '/mydigitalworkers/scout/setup': typeof AppAuthenticatedMydigitalworkersScoutSetupIndexRoute;
  '/mydigitalworkers/gary/settings/accounting-software': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareRoute;
  '/mydigitalworkers/gary/settings/template': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateRoute;
  '/mydigitalworkers/gary/settings/users': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersRoute;
  '/mydigitalworkers/omni/$clientId/$fileName': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameRoute;
  '/mydigitalworkers/omni/settings/ssid': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidRoute;
  '/mydigitalworkers/omni/settings/users': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersRoute;
  '/mydigitalworkers/scout/reports/$reportId': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteWithChildren;
  '/mydigitalworkers/scout/settings/ssid': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidRoute;
  '/mydigitalworkers/scout/settings/users': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersRoute;
  '/mydigitalworkers/gary/settings': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexRoute;
  '/mydigitalworkers/omni/$clientId': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexRoute;
  '/mydigitalworkers/omni/settings': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexRoute;
  '/mydigitalworkers/scout/reports': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexRoute;
  '/mydigitalworkers/scout/settings': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexRoute;
  '/mydigitalworkers/scout/reports/$reportId/$abn/activityStatement': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementRoute;
  '/mydigitalworkers/scout/reports/$reportId/$abn/generalInterests': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsRoute;
  '/mydigitalworkers/scout/reports/$reportId/$abn/ica': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaRoute;
  '/mydigitalworkers/scout/reports/$reportId/$abn/ita': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/_app': typeof AppRouteWithChildren;
  '/_app/_authenticated': typeof AppAuthenticatedRouteWithChildren;
  '/_app/_landing': typeof AppLandingRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers': typeof AppAuthenticatedMydigitalworkersRouteWithChildren;
  '/_app/_authenticated/settings': typeof AppAuthenticatedSettingsRouteWithChildren;
  '/_app/_landing/contact': typeof AppLandingContactRoute;
  '/_app/_landing/pricing': typeof AppLandingPricingRoute;
  '/_app/_landing/privacy': typeof AppLandingPrivacyRoute;
  '/_app/_landing/solutions': typeof AppLandingSolutionsRoute;
  '/_app/auth/login': typeof AppAuthLoginRoute;
  '/_app/auth/logout': typeof AppAuthLogoutRoute;
  '/_app/auth/register': typeof AppAuthRegisterRoute;
  '/_app/auth/renew': typeof AppAuthRenewRoute;
  '/_app/invite/accepted': typeof AppInviteAcceptedRoute;
  '/_app/invite/existing': typeof AppInviteExistingRoute;
  '/_app/invite/new': typeof AppInviteNewRoute;
  '/_app/_landing/': typeof AppLandingIndexRoute;
  '/_app/_authenticated/settings/clients': typeof AppAuthenticatedSettingsClientsRoute;
  '/_app/_authenticated/settings/company': typeof AppAuthenticatedSettingsCompanyRoute;
  '/_app/_authenticated/settings/payment': typeof AppAuthenticatedSettingsPaymentRoute;
  '/_app/_authenticated/settings/profile': typeof AppAuthenticatedSettingsProfileRoute;
  '/_app/_authenticated/settings/subscription': typeof AppAuthenticatedSettingsSubscriptionRoute;
  '/_app/_authenticated/settings/users': typeof AppAuthenticatedSettingsUsersRoute;
  '/_app/_authenticated/setup/employee': typeof AppAuthenticatedSetupEmployeeRoute;
  '/_app/_authenticated/setup/owner': typeof AppAuthenticatedSetupOwnerRoute;
  '/_app/_authenticated/store/accounting': typeof AppAuthenticatedStoreAccountingRoute;
  '/_app/_authenticated/mydigitalworkers/': typeof AppAuthenticatedMydigitalworkersIndexRoute;
  '/_app/_authenticated/settings/': typeof AppAuthenticatedSettingsIndexRoute;
  '/_app/_authenticated/setup/': typeof AppAuthenticatedSetupIndexRoute;
  '/_app/_authenticated/store/': typeof AppAuthenticatedStoreIndexRoute;
  '/_app/_authenticated/mydigitalworkers/gary': typeof AppAuthenticatedMydigitalworkersGaryRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/omni': typeof AppAuthenticatedMydigitalworkersOmniRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/scout': typeof AppAuthenticatedMydigitalworkersScoutRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/about': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutAboutRoute;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/clients': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutClientsRoute;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/workpapers': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutWorkpapersRoute;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/clients': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientsRoute;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/requests': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutRequestsRoute;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/clients': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutClientsRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/requests': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutRequestsRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutIndexRoute;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutIndexRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutIndexRoute;
  '/_app/_authenticated/mydigitalworkers/scout/setup/': typeof AppAuthenticatedMydigitalworkersScoutSetupIndexRoute;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/accounting-software': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsAccountingSoftwareRoute;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/template': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsTemplateRoute;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/users': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsUsersRoute;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/$fileName': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdFileNameRoute;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/ssid': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsSsidRoute;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/users': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsUsersRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdRouteWithChildren;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/ssid': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsSsidRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/users': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsUsersRoute;
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/': typeof AppAuthenticatedMydigitalworkersGaryGaryLayoutSettingsIndexRoute;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutClientIdIndexRoute;
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/': typeof AppAuthenticatedMydigitalworkersOmniOmniLayoutSettingsIndexRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsIndexRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutSettingsIndexRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/activityStatement': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnActivityStatementRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/generalInterests': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnGeneralInterestsRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ica': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnIcaRoute;
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ita': typeof AppAuthenticatedMydigitalworkersScoutScoutLayoutReportsReportIdAbnItaRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | ''
    | '/mydigitalworkers'
    | '/settings'
    | '/contact'
    | '/pricing'
    | '/privacy'
    | '/solutions'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/register'
    | '/auth/renew'
    | '/invite/accepted'
    | '/invite/existing'
    | '/invite/new'
    | '/'
    | '/settings/clients'
    | '/settings/company'
    | '/settings/payment'
    | '/settings/profile'
    | '/settings/subscription'
    | '/settings/users'
    | '/setup/employee'
    | '/setup/owner'
    | '/store/accounting'
    | '/mydigitalworkers/'
    | '/settings/'
    | '/setup'
    | '/store'
    | '/mydigitalworkers/gary'
    | '/mydigitalworkers/omni'
    | '/mydigitalworkers/scout'
    | '/mydigitalworkers/gary/about'
    | '/mydigitalworkers/gary/clients'
    | '/mydigitalworkers/gary/settings'
    | '/mydigitalworkers/gary/workpapers'
    | '/mydigitalworkers/omni/clients'
    | '/mydigitalworkers/omni/requests'
    | '/mydigitalworkers/omni/settings'
    | '/mydigitalworkers/scout/clients'
    | '/mydigitalworkers/scout/requests'
    | '/mydigitalworkers/scout/settings'
    | '/mydigitalworkers/gary/'
    | '/mydigitalworkers/omni/'
    | '/mydigitalworkers/scout/'
    | '/mydigitalworkers/scout/setup'
    | '/mydigitalworkers/gary/settings/accounting-software'
    | '/mydigitalworkers/gary/settings/template'
    | '/mydigitalworkers/gary/settings/users'
    | '/mydigitalworkers/omni/$clientId/$fileName'
    | '/mydigitalworkers/omni/settings/ssid'
    | '/mydigitalworkers/omni/settings/users'
    | '/mydigitalworkers/scout/reports/$reportId'
    | '/mydigitalworkers/scout/settings/ssid'
    | '/mydigitalworkers/scout/settings/users'
    | '/mydigitalworkers/gary/settings/'
    | '/mydigitalworkers/omni/$clientId'
    | '/mydigitalworkers/omni/settings/'
    | '/mydigitalworkers/scout/reports'
    | '/mydigitalworkers/scout/settings/'
    | '/mydigitalworkers/scout/reports/$reportId/$abn/activityStatement'
    | '/mydigitalworkers/scout/reports/$reportId/$abn/generalInterests'
    | '/mydigitalworkers/scout/reports/$reportId/$abn/ica'
    | '/mydigitalworkers/scout/reports/$reportId/$abn/ita';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | ''
    | '/contact'
    | '/pricing'
    | '/privacy'
    | '/solutions'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/register'
    | '/auth/renew'
    | '/invite/accepted'
    | '/invite/existing'
    | '/invite/new'
    | '/'
    | '/settings/clients'
    | '/settings/company'
    | '/settings/payment'
    | '/settings/profile'
    | '/settings/subscription'
    | '/settings/users'
    | '/setup/employee'
    | '/setup/owner'
    | '/store/accounting'
    | '/mydigitalworkers'
    | '/settings'
    | '/setup'
    | '/store'
    | '/mydigitalworkers/gary'
    | '/mydigitalworkers/omni'
    | '/mydigitalworkers/scout'
    | '/mydigitalworkers/gary/about'
    | '/mydigitalworkers/gary/clients'
    | '/mydigitalworkers/gary/workpapers'
    | '/mydigitalworkers/omni/clients'
    | '/mydigitalworkers/omni/requests'
    | '/mydigitalworkers/scout/clients'
    | '/mydigitalworkers/scout/requests'
    | '/mydigitalworkers/scout/setup'
    | '/mydigitalworkers/gary/settings/accounting-software'
    | '/mydigitalworkers/gary/settings/template'
    | '/mydigitalworkers/gary/settings/users'
    | '/mydigitalworkers/omni/$clientId/$fileName'
    | '/mydigitalworkers/omni/settings/ssid'
    | '/mydigitalworkers/omni/settings/users'
    | '/mydigitalworkers/scout/reports/$reportId'
    | '/mydigitalworkers/scout/settings/ssid'
    | '/mydigitalworkers/scout/settings/users'
    | '/mydigitalworkers/gary/settings'
    | '/mydigitalworkers/omni/$clientId'
    | '/mydigitalworkers/omni/settings'
    | '/mydigitalworkers/scout/reports'
    | '/mydigitalworkers/scout/settings'
    | '/mydigitalworkers/scout/reports/$reportId/$abn/activityStatement'
    | '/mydigitalworkers/scout/reports/$reportId/$abn/generalInterests'
    | '/mydigitalworkers/scout/reports/$reportId/$abn/ica'
    | '/mydigitalworkers/scout/reports/$reportId/$abn/ita';
  id:
    | '__root__'
    | '/_app'
    | '/_app/_authenticated'
    | '/_app/_landing'
    | '/_app/_authenticated/mydigitalworkers'
    | '/_app/_authenticated/settings'
    | '/_app/_landing/contact'
    | '/_app/_landing/pricing'
    | '/_app/_landing/privacy'
    | '/_app/_landing/solutions'
    | '/_app/auth/login'
    | '/_app/auth/logout'
    | '/_app/auth/register'
    | '/_app/auth/renew'
    | '/_app/invite/accepted'
    | '/_app/invite/existing'
    | '/_app/invite/new'
    | '/_app/_landing/'
    | '/_app/_authenticated/settings/clients'
    | '/_app/_authenticated/settings/company'
    | '/_app/_authenticated/settings/payment'
    | '/_app/_authenticated/settings/profile'
    | '/_app/_authenticated/settings/subscription'
    | '/_app/_authenticated/settings/users'
    | '/_app/_authenticated/setup/employee'
    | '/_app/_authenticated/setup/owner'
    | '/_app/_authenticated/store/accounting'
    | '/_app/_authenticated/mydigitalworkers/'
    | '/_app/_authenticated/settings/'
    | '/_app/_authenticated/setup/'
    | '/_app/_authenticated/store/'
    | '/_app/_authenticated/mydigitalworkers/gary'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout'
    | '/_app/_authenticated/mydigitalworkers/omni'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout'
    | '/_app/_authenticated/mydigitalworkers/scout'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/about'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/clients'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/workpapers'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/clients'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/requests'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/clients'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/requests'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/'
    | '/_app/_authenticated/mydigitalworkers/scout/setup/'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/accounting-software'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/template'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/users'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/$fileName'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/ssid'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/users'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/ssid'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/users'
    | '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/'
    | '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/activityStatement'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/generalInterests'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ica'
    | '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ita';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren;
}

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app"
      ]
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/_authenticated",
        "/_app/_landing",
        "/_app/auth/login",
        "/_app/auth/logout",
        "/_app/auth/register",
        "/_app/auth/renew",
        "/_app/invite/accepted",
        "/_app/invite/existing",
        "/_app/invite/new"
      ]
    },
    "/_app/_authenticated": {
      "filePath": "_app/_authenticated.tsx",
      "parent": "/_app",
      "children": [
        "/_app/_authenticated/mydigitalworkers",
        "/_app/_authenticated/settings",
        "/_app/_authenticated/setup/employee",
        "/_app/_authenticated/setup/owner",
        "/_app/_authenticated/store/accounting",
        "/_app/_authenticated/setup/",
        "/_app/_authenticated/store/"
      ]
    },
    "/_app/_landing": {
      "filePath": "_app/_landing.tsx",
      "parent": "/_app",
      "children": [
        "/_app/_landing/contact",
        "/_app/_landing/pricing",
        "/_app/_landing/privacy",
        "/_app/_landing/solutions",
        "/_app/_landing/"
      ]
    },
    "/_app/_authenticated/mydigitalworkers": {
      "filePath": "_app/_authenticated/mydigitalworkers.tsx",
      "parent": "/_app/_authenticated",
      "children": [
        "/_app/_authenticated/mydigitalworkers/",
        "/_app/_authenticated/mydigitalworkers/gary",
        "/_app/_authenticated/mydigitalworkers/omni",
        "/_app/_authenticated/mydigitalworkers/scout"
      ]
    },
    "/_app/_authenticated/settings": {
      "filePath": "_app/_authenticated/settings.tsx",
      "parent": "/_app/_authenticated",
      "children": [
        "/_app/_authenticated/settings/clients",
        "/_app/_authenticated/settings/company",
        "/_app/_authenticated/settings/payment",
        "/_app/_authenticated/settings/profile",
        "/_app/_authenticated/settings/subscription",
        "/_app/_authenticated/settings/users",
        "/_app/_authenticated/settings/"
      ]
    },
    "/_app/_landing/contact": {
      "filePath": "_app/_landing/contact.tsx",
      "parent": "/_app/_landing"
    },
    "/_app/_landing/pricing": {
      "filePath": "_app/_landing/pricing.tsx",
      "parent": "/_app/_landing"
    },
    "/_app/_landing/privacy": {
      "filePath": "_app/_landing/privacy.tsx",
      "parent": "/_app/_landing"
    },
    "/_app/_landing/solutions": {
      "filePath": "_app/_landing/solutions.tsx",
      "parent": "/_app/_landing"
    },
    "/_app/auth/login": {
      "filePath": "_app/auth/login.tsx",
      "parent": "/_app"
    },
    "/_app/auth/logout": {
      "filePath": "_app/auth/logout.tsx",
      "parent": "/_app"
    },
    "/_app/auth/register": {
      "filePath": "_app/auth/register.tsx",
      "parent": "/_app"
    },
    "/_app/auth/renew": {
      "filePath": "_app/auth/renew.tsx",
      "parent": "/_app"
    },
    "/_app/invite/accepted": {
      "filePath": "_app/invite/accepted.tsx",
      "parent": "/_app"
    },
    "/_app/invite/existing": {
      "filePath": "_app/invite/existing.tsx",
      "parent": "/_app"
    },
    "/_app/invite/new": {
      "filePath": "_app/invite/new.tsx",
      "parent": "/_app"
    },
    "/_app/_landing/": {
      "filePath": "_app/_landing/index.tsx",
      "parent": "/_app/_landing"
    },
    "/_app/_authenticated/settings/clients": {
      "filePath": "_app/_authenticated/settings/clients.tsx",
      "parent": "/_app/_authenticated/settings"
    },
    "/_app/_authenticated/settings/company": {
      "filePath": "_app/_authenticated/settings/company.tsx",
      "parent": "/_app/_authenticated/settings"
    },
    "/_app/_authenticated/settings/payment": {
      "filePath": "_app/_authenticated/settings/payment.tsx",
      "parent": "/_app/_authenticated/settings"
    },
    "/_app/_authenticated/settings/profile": {
      "filePath": "_app/_authenticated/settings/profile.tsx",
      "parent": "/_app/_authenticated/settings"
    },
    "/_app/_authenticated/settings/subscription": {
      "filePath": "_app/_authenticated/settings/subscription.tsx",
      "parent": "/_app/_authenticated/settings"
    },
    "/_app/_authenticated/settings/users": {
      "filePath": "_app/_authenticated/settings/users.tsx",
      "parent": "/_app/_authenticated/settings"
    },
    "/_app/_authenticated/setup/employee": {
      "filePath": "_app/_authenticated/setup/employee.tsx",
      "parent": "/_app/_authenticated"
    },
    "/_app/_authenticated/setup/owner": {
      "filePath": "_app/_authenticated/setup/owner.tsx",
      "parent": "/_app/_authenticated"
    },
    "/_app/_authenticated/store/accounting": {
      "filePath": "_app/_authenticated/store/accounting.tsx",
      "parent": "/_app/_authenticated"
    },
    "/_app/_authenticated/mydigitalworkers/": {
      "filePath": "_app/_authenticated/mydigitalworkers/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers"
    },
    "/_app/_authenticated/settings/": {
      "filePath": "_app/_authenticated/settings/index.tsx",
      "parent": "/_app/_authenticated/settings"
    },
    "/_app/_authenticated/setup/": {
      "filePath": "_app/_authenticated/setup/index.tsx",
      "parent": "/_app/_authenticated"
    },
    "/_app/_authenticated/store/": {
      "filePath": "_app/_authenticated/store/index.tsx",
      "parent": "/_app/_authenticated"
    },
    "/_app/_authenticated/mydigitalworkers/gary": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary",
      "parent": "/_app/_authenticated/mydigitalworkers",
      "children": [
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary",
      "children": [
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/about",
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/clients",
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings",
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/workpapers",
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/omni": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni",
      "parent": "/_app/_authenticated/mydigitalworkers",
      "children": [
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni",
      "children": [
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/clients",
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/requests",
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings",
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/",
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/$fileName",
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/scout": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout",
      "parent": "/_app/_authenticated/mydigitalworkers",
      "children": [
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout",
        "/_app/_authenticated/mydigitalworkers/scout/setup/"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout",
      "children": [
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/clients",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/requests",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/about": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout/about.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary/_garyLayout"
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/clients": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout/clients.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary/_garyLayout"
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary/_garyLayout",
      "children": [
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/accounting-software",
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/template",
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/users",
        "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/workpapers": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout/workpapers.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary/_garyLayout"
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/clients": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout/clients.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni/_omniLayout"
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/requests": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout/requests.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni/_omniLayout"
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni/_omniLayout",
      "children": [
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/ssid",
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/users",
        "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/clients": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/clients.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/requests": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/requests.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout",
      "children": [
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/ssid",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/users",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary/_garyLayout"
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni/_omniLayout"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout"
    },
    "/_app/_authenticated/mydigitalworkers/scout/setup/": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/setup/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout"
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/accounting-software": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/accounting-software.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/template": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/template.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/users": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/users.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/$fileName": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/$fileName.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni/_omniLayout"
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/ssid": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/ssid.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/users": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/users.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout",
      "children": [
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/activityStatement",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/generalInterests",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ica",
        "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ita"
      ]
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/ssid": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/ssid.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/users": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/users.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/": {
      "filePath": "_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni/_omniLayout"
    },
    "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/": {
      "filePath": "_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/index.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/activityStatement": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn.activityStatement.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/generalInterests": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn.generalInterests.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ica": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn.ica.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId"
    },
    "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ita": {
      "filePath": "_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn.ita.tsx",
      "parent": "/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId"
    }
  }
}
ROUTE_MANIFEST_END */
